import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { motion } from 'framer-motion'

export const OverContainerSection = styled(Box)<{ background: string }>`
    display: flex;
    justify-content: center;
    position: relative;
    padding-top: 60px;
    background: ${({ background }) => background};
`
export const OverContainer = styled(Box)<{
    image: string
}>`
    background: ${({ image }) => `url(${image}) no-repeat center/contain`};
    display: flex;
    height: 250px;
    justify-content: center;
    overflow: hidden;
    align-items: center;
    flex-direction: column;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: column;
        justify-content: center;
        height: 300px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        flex-direction: column;
        align-items: center;
        height: 340px;
        justify-content: center;
    }
`
export const OverSpan = styled.span`
    position: absolute;
    background-size: cover;
    background-position: center center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.6;
    background-image: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.8),
        rgba(0, 0, 0, 0.8)
    );
`
export const ContentTypography = styled(Box)`
    width: 90%;
    justify-content: start;
    align-items: center;
    display: flex;
    height: 50%;
    flex-direction: column;
    z-index: 20;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 95%;
        flex-direction: column;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1200px;
        flex-direction: column;
        height: 60%;
        justify-content: start;
    }
`
export const Back = styled(Box)`
    width: 90%;
    justify-content: start;
    align-items: start;
    display: flex;
    flex-direction: column;
    z-index: 20;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 95%;
        flex-direction: column;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1200px;
        flex-direction: column;
        justify-content: start;
        align-items: start;
    }
`
export const TypographyHeader = styled(motion(Typography))`
    font-family: inherit;
    font-style: normal;
    line-height: 46px;
    color: transparent;
    background: ${({ theme }) => theme.colors.lineaGradiant};
    -webkit-background-clip: text;
    text-align: center;
    text-transform: uppercase;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 54px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 69px;
    }
`
